<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <router-link to="/home">
        <a class="nav-link" href="#pablo">
          <span class="no-icon">首页</span>
        </a>
      </router-link>
    </li>
    <li class="nav-item">
      <router-link to="/admin">
        <a class="nav-link" href="#pablo">
          <span class="no-icon">会议管理</span>
        </a>
      </router-link>
    </li>
    <!-- <li class="nav-item">
      <router-link to="/omanag">
        <a class="nav-link" href="#pablo">
          <span class="no-icon">机构设置</span>
        </a>
      </router-link>
    </li> -->
    <!-- <li class="nav-item">
      <router-link to="/dataStatistics">
        <a class="nav-link" href="#pablo">
          <span class="no-icon">数据统计</span>
        </a>
      </router-link>
    </li> -->
    <!-- <li class="nav-item">
      <a class="nav-link" href="#pablo">
        <span class="no-icon">通知公告</span>
      </a>
    </li> -->

    <li class="nav-item">
       <router-link to="/Guest">
      <a class="nav-link" href="#pablo">
        <span class="no-icon">用户管理</span>
      </a>
       </router-link>
    </li>
    <li class="nav-item">
       <router-link to="/Formation">
      <a class="nav-link" href="#pablo">
        <span class="no-icon">会议资讯管理</span>
      </a>
       </router-link>
    </li>
  </ul>
</template>
<script>
export default {
  name: "mobile-menu",
  data() {
    return {};
  },
};
</script>
<style>
</style>
